<template>
  <div>
    <page-title>Surveys</page-title>

    <loading v-if="loading" />

    <main class="p-surveys-index" v-else>

      <section-block>
        <template slot="header">
          <filter-bar
            resource="Surveys"
            :search-query="searchQuery"
            show-search
            show-filter
            :filter-options="categories"
          ></filter-bar>
        </template>

        <template slot="actions" v-if="$route.meta.isAdmin">
          <base-button
            :primary="true"
            @click="$router.push({ name: 'AdminSurveyCreatePage' })"
            iconBefore="document-create"
            v-if="userCanAdd"
          >
            <span>Add a survey</span>
          </base-button>
        </template>
        <base-empty v-if="!surveys || surveys.length < 1">
          <p>There are no surveys created yet.</p>
        </base-empty>

        <vuetable
          v-else
          class="c-data-table"
          :api-mode="false"
          :fields="table.fields"
          @vuetable:row-clicked="gotoSurvey"
          ref="vuetable"
          :data-manager="dataManager"
          track-by="id"
          no-data-template="<br>No documents were found.<br><br>"
          pagination-path
          @vuetable:pagination-data="onPaginationData"
        >
          <template slot="survey-name" slot-scope="props">
            <div class="c-data-table__cell-icon">
              <span>{{ props.rowData.current_version.title }}</span>
            </div>
          </template>

          <template slot="date-created" slot-scope="props">
            <base-datetime :date="props.rowData.created_time"></base-datetime>
          </template>
          <template slot="category" slot-scope="props">{{
            props.rowData.category ? props.rowData.category.name : "N/A"
          }}</template>

          <template slot="category-actions" slot-scope="props">
            <category-actions
              routePath="AdminSurveyEditPage"
              :id="props.rowData.id"
              deleteAction="Surveys/delete"
              singular="survey"
              :can-delete="userCanDelete"
            >
              <template slot="extra">
                <dropdown-action
                  icon="view"
                  @click="viewEntries(props.rowData.id)"
                  >View entries</dropdown-action
                >
              </template>
            </category-actions>
          </template>
        </vuetable>
        <pagination table-pagination>
          <vuetable-pagination
            ref="pagination"
            @vuetable-pagination:change-page="onChangePage"
          ></vuetable-pagination>
        </pagination>
      </section-block>
    </main>
  </div>
</template>

<script>
const CategoryActions = () => import("@/components/CategoryActions");
const BaseEmpty = () => import("@/components/elements/BaseEmpty");
import { mapState } from "vuex";
import DropdownAction from "@/components/DropdownAction";
import Pagination from '@/components/pagination';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import UserHasPermission from "@/mixins/UserHasPermission";
export default {
  name: "AdminSurveyIndexPage",
  components: {
    BaseEmpty,
    CategoryActions,
    DropdownAction,
    Pagination,
    VuetablePagination,
  },
  mixins: [UserHasPermission],
  props: {},
  data() {
    return {
      loading: true,
      searchQuery: "",

      table: {
        fields: [
          {
            name: "survey-name",
            title: "Survey Name",
            titleClass: "u-ta-left",
            dataClass: "u-ta-left title-col",
            width: "40%",
          },

          {
            name: "category",
            titleClass: "u-ta-left",
            title: "Category",
            width: "20%",
          },
          {
            name: "date-created",
            titleClass: "u-ta-left",
            title: "Date Created",
            width: "20%",
          },
          {
            name: "category-actions",
            title: "Actions",
            titleClass: "u-ta-center u-hide-mobile",
            dataClass: "u-ta-center u-hide-mobile",
            width: "20%",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("Surveys", ["surveys"]),
    ...mapState("SurveyCategories", ["categories"]),
    userCanAdd() {
      return this.userHasPermission("add_surveys");
    },
    userCanDelete() {
      return this.userHasPermission("delete_surveys");
    },
  },
  async created() {
    this.$store.commit("Surveys/setSortBy", {
      direction: "desc",
      field: "created_time",
    });
    const { tab } = this.$route.params;
    await this.$store.dispatch("SurveyCategories/list", { flat: true });
    if (tab) {
      this.$store.commit("Surveys/setTabFilter", tab);
    } else {
      this.$store.commit("Surveys/setTabFilter", 'approved');

    }
    await this.$store.dispatch("Surveys/list", { flat: true });
    this.loading = false;
  },
  methods: {
    dataManager(sortOrder, pagination) {
      const returnObj = {
        ...this.$store.state.Surveys.pagination,
        data: this.surveys,
      };

      return returnObj;
    },
    onPaginationData(paginationData) {
			console.log("TCL:  ~ file: Users.vue ~ line 187 ~ onPaginationData ~ paginationData", paginationData)
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      let nextPage;
      /**
       * Because why would the plugin send actual page numbers
       */
      switch (page) {
        case "next":
          nextPage = ++this.$store.state.Surveys.pagination.current_page;
          break;
        case "prev":
          nextPage = --this.$store.state.Surveys.pagination.current_page;
          break;
        default:
          nextPage = page;
          break;
      }

      const vm = this;
      const tableref = vm.$refs.vuetable;
      this.$store.dispatch("Surveys/list", { page: nextPage, flat: true }).then((resp) => {
        window.scroll(0, 0);
        tableref.changePage(page);
      });
    },
    editSurvey(rowId) {
      console.log(
        "TCL:  ~ file: Index.vue ~ line 160 ~ editSurvey ~ row",
        rowId
      );
      this.$router.push({
        name: "AdminSurveyEditPage",
        params: { id: rowId },
      });
    },
    gotoSurvey(row) {
      if (
        row.event.target.localName === "td" ||
        (row.event.target.parentNode.localName === "td") === "td"
      ) {
        this.$router.push({
          path: `/survey${row.data.survey_url}`,
        });
      }
    },
    userCanView(row) {
      // if the row is private, only primary and secondary users + creator can view it
      if (row.private) {
        return [
          row.primary_user.id,
          row.secondary_user.id,
          row.created_user.id,
        ].includes(this.$store.state.auth.currentUser.id);
      }
      return true;
    },
    viewEntries(id) {
      this.$router.push({
        name: "AdminSurveyEntriesPage",
        params: { id: id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
td > td {
  border: none;
  padding: 0;
  display: inline-block;
}
</style>
